<div class="preloader" *ngIf="isLoading">
    <img class="preloader__image" width="60" src="assets/header-logo.png" alt="img" />
</div>